import { motion, MotionProps } from "framer-motion";
import { FC, HTMLAttributes, useEffect, useState } from "react";

interface Props extends HTMLAttributes<HTMLDivElement> {
    texts?: string[];
}

const SwitchingText: FC<React.PropsWithChildren<React.PropsWithChildren<MotionProps & Props>>> = ({ texts: _texts, ...props }) => {
    const texts = _texts ?? [
        "Bespanne Schläger ...",
        "Sammle Bälle ...",
        "Bereite Platz vor ...",
        "Entstaube die Schuhe ...",
        "Setze die Brille auf ...",
        "Stelle die Uhr ...",
        "Schalte das Licht an ...",
        "Schließe die Tür ...",
        "Öffne das Fenster ...",
        "Schließe die Gardinen ..."
    ];
    const [currentTextIndex, setCurrentTextIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentTextIndex((prev) => {
                let nextIndex = prev + 1;
                if (nextIndex >= texts?.length) return 0;
                return nextIndex;
            });
        }, 2000);

        return () => clearInterval(interval);
    }, []);

    return (<motion.div key={currentTextIndex} initial={{ scale: 0.8, opacity: 0.2 }}
        animate={{ scale: 1, opacity: 1 }} {...props}>
        {texts?.[currentTextIndex]}
    </motion.div>);
};

export default SwitchingText;